<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Almacenes</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row col-md-12"><h5>Información del Almacén</h5></div>

                            <div class="row">

                                <div class="form-group col-xl-2 col-md-6">
                                    <label class="col-form-label" for="inpRegistroSanitario">Registro sanitario</label>
                                    <input formControlName="RegistroSanitario" name="RegistroSanitario" title="" class="form-control" id="inpRegistroSanitario" type="text" value="" maxlength="15">
                                </div>

                                <div class="form-group col-xl-2 col-md-6">
                                    <label class="col-form-label" for="inpRazonSocial">Razón social</label>
                                    <input formControlName="RazonSocial" name="RazonSocial" title="" class="form-control" id="inpRazonSocial" type="text" value="" maxlength="200">
                                </div>

                                <div class="form-group col-xl-2 col-md-6">
                                    <label class="col-form-label" for="inpProvincia">Provincia</label>

                                    <ng-select loadingText="Cargando..." appendTo="body"
                                            [items]="provincias"
                                            placeholder="-- Seleccione una provincia --"
                                            [loading]="!provincias || provincias.length === 0"
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            formControlName="IdProvincia"
                                            [readonly]="!provincias || provincias.length === 0"
                                            notFoundText="Provincia no encontrada"
                                            (change)="onSelectProvincia($event)"
                                            clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-2 col-md-6">
                                    <label class="col-form-label" for="inpMunicipio">Municipio</label>

                                    <ng-select loadingText="Cargando..." appendTo="body"
                                            [items]="municipios"
                                            placeholder="-- Seleccione un municipio --"
                                            [loading]="!municipios && (form.value.IdProvincia > 0)"
                                            bindLabel="Descripcion"
                                            bindValue="Id"
                                            [readonly]="!municipios || municipios.length === 0 || !form.value.IdProvincia"
                                            formControlName="IdMunicipio"
                                            notFoundText="Municipio no encontrado"
                                            clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                                <div class="form-group col-xl-2 col-md-6">
                                    <label class="col-form-label" for="inpActivos">Mostrar solo activos</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listActivos"
                                                    formControlName="Activo"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div *ngIf="mode === dialogMode.Basic" class="form-group col-xl-2 col-md-6">
                                    <label class="col-form-label" for="inpAutorizados">Mostrar solo autorizados</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Autorizado"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" 
                                            [disabled]="disableSearchBtn"
                                            type="submit" title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" 
                                            [disabled]="formIsUntouched()" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div> 
</form>
